define([
	"dojo/_base/array",
	"dojo/_base/declare",
	"dojo/_base/lang",
	"csi",
	"csi/action/Controller",
	"csi/def",
	"csi/locale",
	"csi/reflection"
], function(array, declare, lang, csi, Controller, def, locale, reflection) {

	return declare(Controller, {
		process: function() {
			var w = window.open("", "Site Map");

			this._doc = w.document;
			this._doc.write("<HTML><HEAD><TITLE>Site Map</TITLE></HEAD>");
			this._doc.write("<BODY><pre>");
			this._doc.write("Class,View Id,Class Name,Tab 1,Tab 2,Tab 3\n\n");

			this._writePortal("Host", lang.hitch(this, this._writeSupplier));
		},

		_writePortal: function(/*String*/s, /*Function*/fEnd) {
			var idHost = "__" + s + "__";
			var classes = csi.sort(reflection.getClasses(), function(rc) {return locale.type(rc.getType());});

			var views = csi.transform(classes, function(rc) {
				var defView = (!rc.abstract && !rc.isPrivate()) ? def.getClassViewDef(rc, idHost) : null;
				if (defView) {
					defView.m_rcRoot = rc;
					return defView;
				}

				return null;
			});

			this._doc.write(s + " Portal\n\n");

			csi.forEachWithTimeout(
				views,
				5,
				null,
				function(defView, i, a) {
					this._writeTabs(defView);
				},
				fEnd,
				this);
		},

		_writeSupplier: function() {
			// summary: write out supplier views
			this._doc.write("\n\n");
			this._writePortal("Supplier", lang.hitch(this, this.postProcess, true, false));
		},

		_writeTabs: function(/*def.View*/defView, /*String?*/prefix) {
			// summary: write tabs for type
			var rc = defView.getRootClass();
			var type = rc.getType();
			var bFirst;

			if (prefix == null) {
				bFirst = true;
				prefix = locale.type(type);
			} else {
				prefix += "," + locale.getResolver({typeContext: type}).getTypeView(type, defView.getId());
			}

			if (defView.tabs) {
				// iterate through tabs in Tabs view
				array.forEach(defView.tabs, function(tab) {
					var rcTab = tab.getRootNodeClass(rc);
					var defViewChild = def.getClassViewDef(rcTab, tab.m_idView);
					if (defViewChild) {
						defViewChild.m_rcRoot = rcTab;
						this._writeTabs(defViewChild, prefix);
					} else {
						console.log("Missing: " + type + "," + tab.m_idView);
					}
				}, this);
			} else if (!bFirst) {
				// output line for current tab
				this._doc.write(defView.getTypeNode() + "," + defView.getId() + "," + prefix + "\n");
			}
		},

		postProcessSuccess: function() {
			// summary: finish up
			this._doc.write("</pre></BODY></HTML>");
			this._doc.close();
		}
	});
});